/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 17:07:18
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 11:48:06
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Invoice/Components/ImageUpload/index.tsx
 */
import { Uploader } from '@/src/components';
import { useSingleImageEffect } from '@/src/components/Upload';
import _ from 'lodash';
import React from 'react';
import css from '../../css.module.less';

interface IProps {
  value?: any;
  onChange?: any;
  disabled?: boolean;
}

const ImageUpload = ({ value, onChange, disabled }: IProps) => {
  const [fileList, setFileList] = React.useState(value ? [value] : []);
  useSingleImageEffect(value, fileList, setFileList);

  return (
    <div className={css.upload}>
      <Uploader
        height={180}
        disabled={disabled}
        multiple={false}
        fileList={fileList}
        onChange={(imgArr = []) => {
          setFileList(imgArr);
          // if (onChange) {
          const _l = _.last(imgArr);
          onChange(_l);
          // }
        }}></Uploader>
    </div>
  );
};
export default ImageUpload;
